import React from 'react';
import './HomePage.css';
import columnLogo from '../assets/column_logo.png';
import usePageTitle from '../hooks/usePageTitle';

const HomePage: React.FC = () => {
  usePageTitle('Home');
  return (
    <div className="homepage">
      <div className="hero-section">
        <div className="column-container">
          <img src={columnLogo} alt="Column" className="column-image" />
          <h1 className="brand-name">PRIMUS</h1>
          <p className="brand-tagline">Excellentia per Consilium</p>
        </div>
      </div>
    </div>
  );
};

export default HomePage;